// extracted by mini-css-extract-plugin
export default {"sliderItems":"Slider_sliderItems__QKJGq","viewBtn":"Slider_viewBtn__RmlaQ","sliderTitle":"Slider_sliderTitle__lomMe","sliderPra":"Slider_sliderPra__LKJGn"};